import { render } from "./PEBackground.vue?vue&type=template&id=41ffe9c3&scoped=true"
import script from "./PEBackground.vue?vue&type=script&lang=js"
export * from "./PEBackground.vue?vue&type=script&lang=js"

import "./PEBackground.vue?vue&type=style&index=0&id=41ffe9c3&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ffe9c3"]])

export default __exports__